var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Information Green"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35454",
    d: "M10 2a8 8 0 11-8 8 8.009 8.009 0 018-8m0-2a10 10 0 1010 10A10 10 0 0010 0zm1.25 8.226h-2.5v7.5h2.5zM10 4.274a1.375 1.375 0 101.375 1.375A1.376 1.376 0 0010 4.274z"
  }))));
}
export default SvgInformation;